module.exports = __webpack_public_path__ + "img/box13.0313e781.png";